import templateUrl from 'emun.salesrep/transfer-goals-prompt.htm'
import controller from 'emun.salesrep/transfer-goals-prompt.controller'
import open from "webmodals/open";
import modals from 'webmodals/modals'

const TransferGoalsPrompt = {
    open(options) {
        return modals.open(angular.extend({
            size: 'lg',
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
			controller,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};
export default TransferGoalsPrompt;